import React, { useContext, useEffect, useRef, useState } from "react";
import AccountNavBar from "../../NewComponents/AccountNavBar.js";

import { ReactComponent as DOWN } from "../../assets/icons/filter-down.svg";
import { ReactComponent as UP } from "../../assets/icons/filter-up.svg";
import { ReactComponent as SORT } from "../../assets/icons/sort.svg";
import { ReactComponent as SORTBLACK } from "../../assets/icons/sort-black.svg";
import { ReactComponent as CLIENT } from "../../assets/icons/placed-by.svg";
import { ReactComponent as ROLE } from "../../assets/icons/Role.svg";
import { ReactComponent as LANGUAGES } from "../../assets/icons/Languages.svg";
import { ReactComponent as ACCOUNT } from "../../assets/icons/Account.svg";
import { ReactComponent as COLLABORATION } from "../../assets/icons/Collaboration.svg";
import { ReactComponent as MORE } from "../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../assets/icons/More-selected.svg";

import { AuthContext } from "../../Context/AuthContext.js";
import { TransitionContext } from "../../Context/TransitionContext.js";
import { DataContext } from "../../Context/DataContext.js";
import NoData from "../../NewComponents/NoData.js";
import SendPaymentLinkPopUp from "../../NewComponents/SendPaymentLinkPopUp.js";
import TitleWithSearch from "../../Components/ui/TitleWithSearch.js";
import ClientsNameEmailfilter from "../Account/OrdersComponents/ClientsNameEmailfilter.js";
import SearchFilter from "../Account/OrdersComponents/SearchFilter.js";
import SingleLanguageFilter from "../Account/OrdersComponents/SingleLanguageFilter.js";
import { selectStatusBackground } from "../../Data/statuses.js";
import EmployeeUpdatePopUp from "../../NewComponents/EmployeeUpdatePopUp.js";
import EmployeeAccountСollaboration from "../../NewComponents/EmployeeAccountСollaboration";
import NewButton from "../../NewComponents/NewButton.js";
import { firestore } from "../../firebase.config.js";
import { AccountType } from "../../utility/enums.js";
import { useScreenTransition } from "../../Hooks/useScreenTransition.js";
import ResetPasswordBackend from "../../NewComponents/ResetPasswordBackend.js";

function getLanguageAbbreviations(languages) {
  if (!languages || !languages.length) {
    return "";
  }

  return languages
    .map((language) =>
      language
        .substring(0, 2) // Take the first two characters of the language
        .toUpperCase()
    )
    .join(", "); // Join abbreviations with commas
}

function hasCommonLanguage(array1, array2) {
  if (!Array.isArray(array1) || !Array.isArray(array2)) {
    return false;
  }
  return array2.some((item) => array1.includes(item));
}

const Employees = ({ windowSize }) => {
 const { transitionTo } = useScreenTransition();
  const { setColor } = useContext(TransitionContext);
  const { userData } = useContext(DataContext);

  const { signedIn } = useContext(AuthContext);

  const [selectedSort, setSelectedSort] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");

  const [selectedLanguagesFilter, setSelectedLanguagesFilter] = useState([]);
  const [showDetailModal, setShowDetailModal] = useState("");
  const [showFilter, setShowFilter] = useState("");
  const [employees, setEmployees] = useState([]);

  const [filterdEmployees, setFilterdEmployees] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [filterSearch, setFilterSearch] = useState("");
  const [selectedSendPayment, setSelectedSendPayment] = useState("");
  const [roleFilter, setRoleFilter] = useState([]);
  const [moreOptions, setMoreOptions] = useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [currentEmployee, setCurrentEmployee] = useState(null);

  const [showAccount, setShowAccount] = useState(false);
  const [showCollaboration, setShowCollaboration] = useState(false);
  const [showSupportRemoveEmployee, setSupportRemoveEmployee] = useState(false);
  const [showRemoveEmployee, setRemoveEmployee] = useState(false);
  const [title, setTitle] = useState("");
  const [discription, setDiscription] = useState("");
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [resetPasswordBtn, setResetPasswordBtn] = useState("Reset Password");

  let nextPointer = useRef();
  if (!nextPointer.current) nextPointer.current = null;

  useEffect(() => {
    setColor(true);
  }, [setColor]);

   useEffect(() => {
        if(!signedIn || (userData && userData.role === "client")){
          return transitionTo("/");
        }
      }, [signedIn, userData]);

  useEffect(() => {
    let filterdData = [...employees];
    if (selectedClients && selectedClients.length) {
      const selectedClientsNames = selectedClients?.map((el) => el.name);
      const selectedClientsEmails = selectedClients?.map((el) => el.email);
      filterdData = filterdData.filter(
        (item) =>
          selectedClientsNames?.includes(item.name) ||
          selectedClientsEmails?.includes(item.email)
      );
    }

    if (roleFilter && roleFilter.length) {
      filterdData = filterdData.filter((item) =>
        roleFilter?.includes(item.role)
      );
    }

    if (selectedLanguagesFilter && selectedLanguagesFilter.length) {
      filterdData = filterdData.filter((item) =>
        hasCommonLanguage(item.languages, selectedLanguagesFilter)
      );
    }

    if (filterSearch) {
      filterdData = filterdData.filter((item) => {
        return (
          item.email
            ?.toLowerCase()
            .includes(filterSearch.trim().toLowerCase()) ||
          item.name?.toLowerCase().includes(filterSearch.trim().toLowerCase())
        );
      });
    }
    setFilterdEmployees(filterdData);
  }, [
    employees,
    selectedClients,
    roleFilter,
    selectedLanguagesFilter,
    filterSearch,
  ]);

  const fetchEmployees = () => {
    let isMounted = true;
  
    firestore
      .collection("users").where("role", "in", [AccountType.SUPPORT, AccountType.SUPPORTPLUS, AccountType.TRANSLATER])
      .orderBy("timestamp", "desc")
      .get()
      .then((qSnap) => {
        if (isMounted && !qSnap.empty) {
          const employeesData = qSnap.docs
            .map((doc) => ({ ...doc.data(), id: doc.id }))
          setEmployees(employeesData);
        }
      })
      .catch((error) => {
        console.error("Error fetching employees:", error);
      });
  
    return () => {
      isMounted = false;
    };
  };
  

  useEffect(() => {
    const cleanup = fetchEmployees();
    return cleanup;
  }, [signedIn, userData]);
  

  const sortedEmployees = [...filterdEmployees].sort((a, b) => {
    if (selectedSort === "name") {
      return sortOrder === "asc"
        ? (a.name || "").localeCompare(b.name || "")
        : (b.name || "").localeCompare(a.name || "");
    } else if (selectedSort === "languages") {
      return sortOrder === "asc"
        ? (a.languages || []).length - (b.languages || []).length
        : (b.languages || []).length - (a.languages || []).length;
    } else if (selectedSort === "role") {
      return sortOrder === "asc"
        ? (a.role || "").localeCompare(b.role || "")
        : (b.role || "").localeCompare(a.role || "");
    } else if (selectedSort === "status") {
      return sortOrder === "asc"
        ? (a.status || "").localeCompare(b.status || "")
        : (b.status || "").localeCompare(a.status || "");
    }
    return 0;
  });

  const toggleSort = (column) => {
    if (selectedSort === column) {
      setSortOrder((prevOrder) => (prevOrder === "desc" ? "asc" : "desc"));
    } else {
      setSelectedSort(column);
      setSortOrder("desc"); // Default sorting when switching columns
    }
  };

  const checkAnyFilterSelected = () => {
    if (filterSearch !== "") {
      return true;
    } else {
    }
    return false;
  };

  const btnEditEmployee = (employee) => {
    setCurrentEmployee(employee);
    setEditModalOpen(true);
  };

  const btnAddEmployee = () => {
    setCurrentEmployee(null);
    setEditModalOpen(true);
  };

  const btnPauseAccount = (employee) => {
    setShowAccount(true);
    setTitle("Pause Account");
    setCurrentEmployee(employee);
    setDiscription(
      "The support account will be temporarily paused. Support will not have access to the account."
    );
  };
  const btnActivateAccount = (employee) => {
    setShowAccount(true);
    setCurrentEmployee(employee);
    setTitle("Activate Account");
    setDiscription(
      "The support account will be Activated. Support will have access to the account."
    );
  };
  const btnPauseCollaboration = (employee) => {
    setCurrentEmployee(employee);
    setShowCollaboration(true);
    setTitle("Pause Collaboration");
    setDiscription(
      "Collaboration with the translator will be temporarily paused. This is purely an informational action and does not involve any further consequences."
    );
  };
  const btnActivateCollaboration = (employee) => {
    setCurrentEmployee(employee);
    setShowCollaboration(true);
    setTitle("Activate Collaboration");
    setDiscription(
      "Collaboration with the translator will be Activated. This is purely an informational action and does involve any further consequences."
    );
  };
  const btnSupportRemoveEmployee = (employee) => {
    setTitle("Remove Employee");
    setSupportRemoveEmployee(true);
    setDiscription("Are you sure you want to remove this employee?");
    setCurrentEmployee(employee);
  };
  const btnRemoveEmployee = (employee) => {
    setTitle("Remove Employee");
    setRemoveEmployee(true);
    setDiscription("Are you sure you want to remove this employee?");
    setCurrentEmployee(employee);
  };
  const btnClose = () => {
    setEditModalOpen(false);
    setShowAccount(false);
    setShowCollaboration(false);
    setSupportRemoveEmployee(false);
    setRemoveEmployee(false);
    fetchEmployees();
  };

  const resetPassword = () => {
    setShowResetPassword(true);
  }
  return (
    <>
      {selectedSendPayment !== "" && (
        <SendPaymentLinkPopUp
          data={selectedSendPayment}
          type="order"
          id={selectedSendPayment.id}
          onClose={() => setSelectedSendPayment("")}
        />
      )}

      {showResetPassword && (
        <ResetPasswordBackend onClose={() => setShowResetPassword(false)}/>
      )}

      <AccountNavBar
        windowSize={windowSize}
        selectedTab="employees"
        accountMainPadding={false}
        admin={true}
        showButton={true}
      >
        <TitleWithSearch
          title="Employees"
          placeholder="Search by name, email"
          onSearch={(val) => setFilterSearch(val)}
        />
        <div className="w-full flex lg:flex-row lg:justify-between items-center flex-col gap-4 md:px-5 px-2">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 lg:w-fit w-full gap-4">
            {editModalOpen && (
              <EmployeeUpdatePopUp
                id={currentEmployee || {}}
                onClose={() => btnClose()}
              />
            )}

            {showAccount && (
              <EmployeeAccountСollaboration
                currentEmployee={currentEmployee}
                title={title}
                text={discription}
                iconBgColor="#FFF6EA"
                deleteBtn={true}
                onClose={() => btnClose()}
              >
                <ACCOUNT />
              </EmployeeAccountСollaboration>
            )}

            {showCollaboration && (
              <EmployeeAccountСollaboration
                currentEmployee={currentEmployee}
                title={title}
                text={discription}
                iconBgColor="#FFF6EA"
                deleteBtn={true}
                onClose={() => btnClose()}
              >
                <COLLABORATION />
              </EmployeeAccountСollaboration>
            )}
            {showSupportRemoveEmployee && (
              <EmployeeAccountСollaboration
                currentEmployee={currentEmployee}
                title={title}
                text={discription}
                subText={currentEmployee}
                iconBgColor="#FFF6EA"
                deleteBtn={true}
                onClose={() => btnClose()}
              >
                <ACCOUNT />
              </EmployeeAccountСollaboration>
            )}
            {showRemoveEmployee && (
              <EmployeeAccountСollaboration
                currentEmployee={currentEmployee}
                title={title}
                text={discription}
                subText={currentEmployee}
                iconBgColor="#FFF6EA"
                deleteBtn={true}
                onClose={() => btnClose()}
              >
                <COLLABORATION />
              </EmployeeAccountСollaboration>
            )}

            <div className="relative">
              <div
                className="accountDetailsFilter"
                style={{
                  borderColor:
                    showFilter === "name" || selectedClients.length > 0
                      ? "#12ABBF"
                      : "#E6E7E9",
                }}
                onClick={(e) => {
                  setShowFilter((f) => (f === "name" ? "" : "name"));
                }}
              >
                <CLIENT />
                <p className="accountDetailsFilterText">
                  Employees{" "}
                  {selectedClients.length > 0
                    ? ` (${selectedClients.length}) `
                    : ""}
                </p>
                {showFilter === "name" ? <UP /> : <DOWN />}
              </div>
              {showFilter === "name" && (
                <ClientsNameEmailfilter
                  setShowModal={setShowFilter}
                  clients={employees}
                  setSelectedClients={setSelectedClients}
                  selectedClients={selectedClients}
                  isFirst={true}
                />
              )}
            </div>
            <div className="relative">
              <div
                className="accountDetailsFilter"
                style={{
                  borderColor:
                    showFilter === "language" ||
                    selectedLanguagesFilter.length > 0
                      ? "#12ABBF"
                      : "#E6E7E9",
                }}
                onClick={(e) => {
                  setShowFilter((f) => (f === "language" ? "" : "language"));
                }}
              >
                <LANGUAGES />
                <p className="accountDetailsFilterText">
                  Languages{" "}
                  {selectedLanguagesFilter.length > 0
                    ? ` (${selectedLanguagesFilter.length}) `
                    : ""}
                </p>
                {showFilter === "language" ? <UP /> : <DOWN />}
              </div>
              {showFilter === "language" && (
                <SingleLanguageFilter
                  setShowModal={setShowFilter}
                  setSelectedLanguageFilter={setSelectedLanguagesFilter}
                  selectedLanguageFilter={selectedLanguagesFilter}
                />
              )}
            </div>
            <div className="relative">
              <div
                className="accountDetailsFilter"
                style={{
                  borderColor:
                    showFilter === "role" || roleFilter.length > 0
                      ? "#12ABBF"
                      : "#E6E7E9",
                }}
                onClick={(e) => {
                  setShowFilter((f) => (f === "role" ? "" : "role"));
                }}
              >
                <ROLE />
                <p className="accountDetailsFilterText">
                  Role {roleFilter.length > 0 ? ` (${roleFilter.length}) ` : ""}
                </p>
                {showFilter === "role" ? <UP /> : <DOWN />}
              </div>
              {showFilter === "role" && (
                <SearchFilter
                  quote={false}
                  type="role"
                  setStatusFilter={setRoleFilter}
                  selectedFilters={roleFilter}
                  setShowModal={setShowFilter}
                />
              )}
            </div>

            <div className="md:hidden flex gap-2 w-full flex-wrap">
              <NewButton
              text="Reset Password"
              onClick={() => resetPassword()}
              back
              icon={false}
              whiteBtn
              width="150px"
            />
              <NewButton
                text="Add Employee"
                onClick={() => btnAddEmployee()}
                back
                icon={false}
                whiteBtn
                width="100%"
              />
            </div>
          </div>

          <div className=" md:flex hidden gap-2 flex-wrap">
            <NewButton
              text="Reset Password"
              onClick={() => resetPassword()}
              back
              icon={false}
              whiteBtn
              width="150px"
            />
            <NewButton
              text="Add Employee"
              onClick={() => btnAddEmployee()}
              back
              icon={false}
              whiteBtn
              width="150px"
            />
          </div>
        </div>

        {filterdEmployees?.length === 0 && !checkAnyFilterSelected() ? (
          <NoData type="employee" loading={true} showBtn={false} loadingText={"employees"} />
        ) : (
          <div className="accountDetailsScroll w-full">
            <table className="accountDetailsTable">
              <thead>
                <tr>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Employee Name</p>
                      {selectedSort === "name" ? (
                        sortOrder === "desc" ? (
                          <SORT
                            className="sortIcon"
                            onClick={() => toggleSort("name")}
                          />
                        ) : (
                          <SORTBLACK
                            className="sortIcon"
                            onClick={() => toggleSort("name")}
                          />
                        )
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => toggleSort("name")}
                        />
                      )}
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Employee email</p>
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Languages</p>
                      {selectedSort === "languages" ? (
                        sortOrder === "desc" ? (
                          <SORT
                            className="sortIcon"
                            onClick={() => toggleSort("languages")}
                          />
                        ) : (
                          <SORTBLACK
                            className="sortIcon"
                            onClick={() => toggleSort("languages")}
                          />
                        )
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => toggleSort("languages")}
                        />
                      )}
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Role</p>
                      {selectedSort === "role" ? (
                        sortOrder === "desc" ? (
                          <SORT
                            className="sortIcon"
                            onClick={() => toggleSort("role")}
                          />
                        ) : (
                          <SORTBLACK
                            className="sortIcon"
                            onClick={() => toggleSort("role")}
                          />
                        )
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => toggleSort("role")}
                        />
                      )}
                    </div>
                  </th>
                  <th>
                    <div
                      className="accountData"
                      style={{ justifyContent: "center", maxWidth: "170px" }}
                    >
                      <p className="accountDetailsHeading">Status</p>
                      {selectedSort === "status" ? (
                        sortOrder === "desc" ? (
                          <SORT
                            className="sortIcon"
                            onClick={() => toggleSort("status")}
                          />
                        ) : (
                          <SORTBLACK
                            className="sortIcon"
                            onClick={() => toggleSort("status")}
                          />
                        )
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => toggleSort("status")}
                        />
                      )}
                    </div>
                  </th>
                  <th></th>
                </tr>
              </thead>
              {filterdEmployees?.length > 0 && (
                <tbody>
                  {sortedEmployees.map((employee, i) => (
                    <tr key={employee.id + i}>
                      <td>
                        {
                          showDetailModal ===
                            employee.id
                               && (
                            <div className="accountdetailHoverBox">
                              <p
                                className="accountDetailsText captialLetters"
                              >
                                {employee.name}
                              </p>
                            </div>
                          )}
                        <p
                          className="accountDetailsText captialLetters"
                          style={{ cursor: "pointer" }}
                          onMouseOver={() =>
                            setShowDetailModal(
                              employee.id
                            )
                          }
                          onMouseLeave={() => setShowDetailModal("")}
                        >
                          {employee.name ?? (employee.firstName + " " + employee.lastName || "-")}
                        </p>
                      </td>
                      <td>
                        {employee.email &&
                          employee.email?.length > 15 &&
                          showDetailModal === employee.id + employee.email && (
                            <div className="accountdetailHoverBox">
                              <p
                                className="accountDetailsText lowercaseLetter"
                               
                              >
                                {employee.email}
                              </p>
                            </div>  
                          )}
                        <p
                          className="accountDetailsText lowercaseLetter"
                          style={{ cursor: "pointer" }}
                          onMouseOver={() =>
                            setShowDetailModal(employee.id + employee.email)
                          }
                          onMouseLeave={() => setShowDetailModal("")}
                        >
                          {employee.email || "-"}
                        </p>
                      </td>
                      <td>
                        {employee.languages &&
                          showDetailModal ===
                            employee.id + employee.languages && (
                            <div className="accountdetailHoverBox">
                              <p
                                className="accountDetailsText captialLetters"
                              >
                                {employee.languages.join(", ")}
                              </p>
                            </div>
                          )}
                        <p
                          className="accountDetailsText "
                          onMouseOver={() =>
                            setShowDetailModal(employee.id + employee.languages)
                          }
                          onMouseLeave={() => setShowDetailModal("")}
                        >
                          {getLanguageAbbreviations(employee.languages) || " "}
                        </p>
                      </td>
                      <td>
                        <p className="accountDetailsText">{employee.role}</p>
                      </td>
                      <td className="flex justify-center">
                        {employee.status ? (
                          <>
                            <p
                              className="accountDetailsText accountDetailsStatus"
                              style={
                                employee.status
                                  ? {
                                      backgroundColor: selectStatusBackground(
                                        employee.status
                                      ),
                                    }
                                  : {}
                              }
                            >
                              {employee.status ? employee.status : "-"}
                            </p>
                          </>
                        ) : (
                          <>
                            <p className="accountDetailsText">-</p>
                          </>
                        )}
                      </td>
                      {
                        <td>
                          <div
                            className="hardCopyAddressIconWrap"
                            onClick={(e) => {
                              e.stopPropagation(); // Prevents event bubbling
                              setMoreOptions((prev) =>
                                prev === employee.id ? "" : employee.id
                              );
                            }}
                            tabIndex={0} // Enables blur event for accessibility
                            onBlur={() => setMoreOptions("")}
                          >
                            {moreOptions === employee.id ? (
                              <MORESELECTED
                                className="hardCopyAddressIcon"
                                // onClick={() => setMoreOptions("")}
                              />
                            ) : (
                              <MORE
                                className="hardCopyAddressIcon"
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevents event bubbling
                                  setMoreOptions((prev) =>
                                    prev === employee.id ? "" : employee.id
                                  );
                                }}
                              />
                            )}

                            {moreOptions === employee.id && (
                              <div className="hardCopyAddressEditWrap">
                                <div
                                  className="hardCopyAddressEdit"
                                  onClick={() => btnEditEmployee(employee)}
                                >
                                  Edit Employee
                                </div>
                                {employee.role === "Support" &&
                                  employee.status === "Active" && (
                                    <div
                                      className="hardCopyAddressEdit"
                                      onClick={() => btnPauseAccount(employee)}
                                    >
                                      Pause Account
                                    </div>
                                  )}
                                {employee.role === "Support" &&
                                  employee.status !== "Active" && (
                                    <div
                                      className="hardCopyAddressEdit"
                                      onClick={() =>
                                        btnActivateAccount(employee)
                                      }
                                    >
                                      Activate Account
                                    </div>
                                  )}
                                {employee.role !== "Support" &&
                                  employee.status === "Active" && (
                                    <div
                                      className="hardCopyAddressEdit"
                                      onClick={() =>
                                        btnPauseCollaboration(employee)
                                      }
                                    >
                                      Pause Сollaboration
                                    </div>
                                  )}
                                {employee.role !== "Support" &&
                                  employee.status !== "Active" && (
                                    <div
                                      className="hardCopyAddressEdit"
                                      onClick={() =>
                                        btnActivateCollaboration(employee)
                                      }
                                    >
                                      Activate Сollaboration
                                    </div>
                                  )}
                                {employee.role === "Support" && (
                                  <div
                                    className="hardCopyAddressEdit"
                                    onClick={() =>
                                      btnSupportRemoveEmployee(employee)
                                    }
                                  >
                                    Remove Employee
                                  </div>
                                )}
                                {employee.role !== "Support" && (
                                  <div
                                    className="hardCopyAddressEdit"
                                    onClick={() => btnRemoveEmployee(employee)}
                                  >
                                    Remove Employee
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </td>
                      }
                    </tr>
                  ))}
                </tbody>
              )}
            </table>

            {filterdEmployees?.length === 0 && checkAnyFilterSelected() ? (
              <NoData type="employee" loading={true} showBtn={false} loadingText={"employees"}/>
            ) : null}
          </div>
        )}
      </AccountNavBar>
    </>
  );
};

export default Employees;
